
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useState } from "react";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface ForwardActionValue {
  email: string;
}

interface ForwardActionProps {
  value: ForwardActionValue;
  onChange: (value: ForwardActionValue) => void;
}

export function ForwardAction({ value, onChange }: ForwardActionProps) {
  const [error, setError] = useState<string | null>(null);

  const handleEmailChange = (email: string) => {
    setError(null);
    onChange({ ...value, email });
  };

  const validateEmail = () => {
    if (!value.email) {
      setError("Email address is required");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value.email)) {
      setError("Invalid email format");
      return;
    }

    setError(null);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-medium">Forward Email Address</label>
        <Input
          type="email"
          placeholder="email@example.com"
          value={value.email}
          onChange={(e) => handleEmailChange(e.target.value)}
          onBlur={validateEmail}
          className={error ? "border-red-500" : ""}
        />
        {error && (
          <Alert variant="destructive" className="mt-2 py-2">
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}
        <p className="text-xs text-muted-foreground mt-1">
          The email will be forwarded to this address
        </p>
      </div>
    </div>
  );
}
